export default {
  gql: {
    GET_CREDIT_CARD: `
      query GetCreditCard($id: String!) {
        getCreditCard(id: $id) {
          name
          type
          brand
          token
          number
          dueDate
          country
          walletId
        }
      }
    `,
    GET_CREDIT_CARDS: `
      query GetCreditCards($accountId: String) {
        getAccountCreditCards(accountId: $accountId) {
          id
          name
          type
          brand
          token
          number
          dueDate
          country
          walletId
        }
      }
    `,
    SET_CREDIT_CARD: `
      mutation SetCreditCard(
        $id: String!
        $name: String
        $type: String
        $brand: String
        $token: String!
        $number: String!
        $country: String
        $dueDate: String!
        $accountId: String
        $walletId: String
        $paymentRecordId: String
      ) {
        setAccountCreditCard(
          id: $id
          name: $name
          type: $type
          brand: $brand
          token: $token
          number: $number
          dueDate: $dueDate
          country: $country
          accountId: $accountId
          walletId: $walletId
          paymentRecordId: $paymentRecordId
        ) {
          id
          name
          type
          brand
          token
          number
          dueDate
          country
          walletId
          paymentRecordId
        }
      }
    `,
  },
};
